import * as React from 'react'
import { Button, Col, Container, Form, Image, Row, Spinner, Table } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import * as _ from 'lodash'
import { AuthStateT } from '../../redux/reducers/authReducer'
import { IAppState } from '../../redux/reducers'
import { companyObj, CompanyT } from '../../types/Company';
import { useRouteMatch } from 'react-router'
import { AxiosInstance } from '../../utils/RequestMethods';
import config from '../../constants/config';
import { copyObject, formatPhoneNumberUS } from '../../utils';
import images from '../../constants/images';
import Notfound from '../Notfound/Notfound';

import Booking from '../Plugin_Booking/Booking'
import Testimonials from './Testimonials'
import { Grid } from '@mui/material'


export type ICompanyProfileProps = {

}

const CompanyProfile: React.FC<ICompanyProfileProps> = ({ }) => {
  const auth: AuthStateT = useSelector((state: IAppState) => state.auth)
  const [isReady, setIsReady] = React.useState(false);
  const [company, setCompany] = React.useState<CompanyT | null>(null);
  const [companyHandle, setCompanyHandle] = React.useState("");
  const [notFound, setNotFound] = React.useState(false);
  const match = useRouteMatch()



  React.useEffect(() => {
    if (match && match.params && match.params.companyHandle) {
      if (match.params.companyHandle != "" && match.params.companyHandle != null) {
        setCompanyHandle(match.params.companyHandle)
        getCompany(match.params.companyHandle)
      }
    }
  }, [])



  const getCompany = async (companyHandle: string): Promise<void> => {

    AxiosInstance.get(`${config.url.companies}/${companyHandle}`).then((res) => {
      if (res && res.data) {
        let resCompany = copyObject({ ...companyObj, ...res.data })
        // console.log('RESCOMPANY: ', resCompany)
        setCompany(resCompany)
      }
      setIsReady(true)
    }).catch((error) => {
      setIsReady(true)
      setNotFound(true)
    })
  }

  if (isReady && notFound == true) {
    return (
      <Notfound />
    )
  }

  if (!isReady || !company) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" variant="info" />
      </Container>
    )
  }

  const renderPayment = (): JSX.Element => {
    return (
      <div style={{
        backgroundColor: '#fff',
        border: '1px solid #dee2e6',
        borderRadius: 10,
        padding: '24px 20px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.07)',
      }}>
        <h2 style={{ marginBottom: 16, borderBottom: '2px solid #6AD959', paddingBottom: 8, textAlign: 'center' }}>
          📦 Book a Move
        </h2>
        <Booking company={company} handle={companyHandle} />
      </div>
    )
  }

  const renderPricing = (): JSX.Element => {
    const rateList: Array<string> = [
      'hourlyRateOne',
      'hourlyRateTwo',
      'hourlyRateThree',
      'hourlyRateFour'
    ]


    return (
      <div style={{ width: '100%' }}>
        <h2 style={{ marginBottom: 16, borderBottom: '2px solid #6AD959', paddingBottom: 8 }}>
          💲 Rates
        </h2>
        <Table bordered hover striped style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Service</th>
              <th>Rate</th>
            </tr>
          </thead>
          <tbody>
            {rateList.map((rate: string, index: number): JSX.Element => {
              return (
                <tr key={index}>
                  <td>{_.has(company.variables, rate) ? company.variables[rate].verboseName : ""}</td>
                  <td>${_.has(company.variables, rate) ? company.variables[rate].value : 0} / hour</td>
                </tr>
              )
            })}
          </tbody>
        </Table>
        <h4>Notes</h4>
        <ul>
          <li><strong>${_.has(company.variables, "depositLocal") ? company?.variables?.depositLocal?.value.toFixed(2) : "0.00"} booking fee</strong></li>
          <li>2-hour minimum</li>
          <li>This rate does not include a truck</li>
        </ul>
      </div>
    )
  }


  return (
    <div className="mt-2">
      <Grid container spacing={0}>

        {/* ── Hero / Header Section ─────────────────────────────── */}
        <Grid item xs={12} style={{ backgroundColor: '#F0F0F0' }}>
          <Grid container spacing={2} alignItems="center" className="p-3 p-md-4">
            {/* Logo */}
            <Grid item xs={12} sm="auto" style={{ display: 'flex', justifyContent: 'center' }}>
              <Image
                src={company.logo ? company.logo : images.noProfilePic}
                style={{
                  width: 130,
                  height: 130,
                  objectFit: 'cover',
                  borderRadius: '50%',
                  border: '3px solid #fff',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                }}
              />
            </Grid>
            {/* Info */}
            <Grid item xs={12} sm>
              <h1 style={{ marginBottom: 6, fontSize: 'clamp(1.4rem, 4vw, 2rem)' }}>{company.name}</h1>
              {company.smuvsPhone && (
                <div style={{ marginBottom: 4 }}>
                  <i className="fa fa-phone" style={{ marginRight: 6 }} />
                  {formatPhoneNumberUS(company.smuvsPhone, false)}
                </div>
              )}
              {company.address && (
                <div style={{ marginBottom: 12 }}>
                  <i className="fa fa-map-marker" style={{ marginRight: 6 }} />
                  {company.address}
                </div>
              )}
              {/* Book Now button */}
              <button
                onClick={() => {
                  document.getElementById('booking-section')?.scrollIntoView({ behavior: 'smooth' })
                }}
                style={{
                  backgroundColor: '#6AD959',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 24,
                  padding: '10px 24px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  boxShadow: '0 3px 10px rgba(106,217,89,0.45)',
                  transition: 'transform 0.15s, box-shadow 0.15s',
                }}
                onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.04)')}
                onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
              >
                📦 Book Now
              </button>
            </Grid>
          </Grid>
        </Grid>

        {/* ── About Section ────────────────────────────────────── */}
        <Grid item xs={12}>
          <Grid container spacing={2} alignItems="center" className="p-3 p-md-4">
            <Grid item xs={12} sm={3} style={{ textAlign: 'center' }}>
              <Image
                src={images.james}
                style={{
                  width: 140,
                  height: 140,
                  objectFit: 'cover',
                  borderRadius: '50%',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                }}
              />
              <p className="text-muted mt-2 mb-0" style={{ fontStyle: 'italic', fontSize: '0.85rem' }}>
                James Rodriguez - Owner
              </p>
            </Grid>
            <Grid item xs={12} sm={9}>
              <p style={{ lineHeight: 1.7, fontSize: '1rem', margin: 0 }}>{company.description}</p>
            </Grid>
          </Grid>
        </Grid>

        {/* ── Pricing ──────────────────────────────────────────── */}
        <Grid item xs={12}>
          <div className="p-3 p-md-4 mt-2" style={{
            borderTop: '1px solid #dee2e6',
          }}>
            {renderPricing()}
          </div>
        </Grid>

        {/* ── Testimonials ─────────────────────────────────────── */}
        <Grid item xs={12}>
          <div className="p-3 p-md-4 mt-2" style={{
            borderTop: '1px solid #dee2e6',
          }}>
            <h2 style={{ marginBottom: 16, borderBottom: '2px solid #6AD959', paddingBottom: 8 }}>
              ⭐ Testimonials
            </h2>
            <Testimonials />
          </div>
        </Grid>

        {/* ── Booking ──────────────────────────────────────────── */}
        <Grid item xs={12} id="booking-section" style={{ backgroundColor: '#f8f9fa' }}>
          <div className="p-3 p-md-4 mt-2 mb-4">
            {renderPayment()}
          </div>
        </Grid>

      </Grid>
    </div>
  );
}
export default CompanyProfile
export { CompanyProfile }
